module.exports = __webpack_public_path__ + "img/knight4cf_feature_02.6ab10959.jpg";